<script context="module">
    import {isLoggedIn, session} from 'src/services/auth'
    import {navigate} from 'src/global/navigate'
</script>
<script lang="ts">
    import {Route} from 'svelte-routing'
    import Login from './login/Login.svelte'
    import Dashboard from './dashboard/Dashboard.svelte'
    import Analytics from './analytics/Analytics.svelte'

    import Transactions from './transactions/Transactions.svelte'
    import Refunds from './refunds/Refunds.svelte'
    import Withdrawals from './withdrawals/Withdrawals.svelte'
    import Deposits from './deposits/Deposits.svelte'
    import Marketplace from './transactions/components/Marketplace.svelte';
    import Swaps from './transactions/components/Swap.svelte'

    import Users from './users/Users.svelte'
    import Holders from './holders/Holders.svelte'
    import Profile from './profile/Profile.svelte'
    import MultiAccounts from './users/MultiAccounts.svelte';
    import MembershipOwners from './users/MembershipOwners.svelte';

    import Memberships from './memberships/Memberships.svelte'
    import Membership from './memberships/components/Edit.svelte'
    import MembershipAdd from './memberships/components/Add.svelte'

    import Notifications from './notifications/Notifications.svelte'

    import Administrators from './administrators/Administrators.svelte'
    import AdministratorsRoleAdd from './administrators/components/AddRole.svelte'
    import AdministratorsRoleEdit from './administrators/components/EditRole.svelte'

    import Swap from './swap/Swap.svelte'
    import SwapEdit from './swap/components/SwapEdit.svelte'
    import SwapAdd from './swap/components/SwapAdd.svelte'
    import SwapTokens from './swap/components/SwapTokenList.svelte'
    import SwapTokenAdd from './swap/components/SwapTokenAdd.svelte'
    import SwapTokenEdit from './swap/components/SwapTokenEdit.svelte'

    import Nft from './nft/Nft.svelte'
    import NftImages from './nft/components/Images.svelte'
    import NftItems from './nft/components/Items.svelte'

    import DepositWallets from './deposit-wallets/DepositWallets.svelte'

    import Emails from './emails/Emails.svelte'
    import EmailAdd from './emails/components/Add.svelte'
    import EmailEdit from './emails/components/Edit.svelte'

    import Blog from './blog/Blog.svelte'
    import BlogArticleAdd from './blog/components/ArticleAdd.svelte'
    import BlogArticleEdit from './blog/components/ArticleEdit.svelte'
    import BlogCategories from './blog/components/Categories.svelte'
    import BlogCategoryAdd from './blog/components/CategoryAdd.svelte'
    import BlogCategoryEdit from './blog/components/CategoryEdit.svelte'

    import Poll from './polls/Poll.svelte'
    import PollAdd from './polls/components/PollAdd.svelte'
    import PollEdit from './polls/components/PollEdit.svelte'

    import News from './news/News.svelte'
    import NewsAdd from './news/components/NewsAdd.svelte'
    import NewsEdit from './news/components/NewsEdit.svelte'

    import Confirmations from './confirmations/Confirmations.svelte'
    import Actions from './actions/Actions.svelte'

    import AppConfigs from './app-configs/AppConfigs.svelte'
    import AppConfigsApp from './app-configs/components/App.svelte'

    import UserTasks from './tasks-bot/UserTasks.svelte'
    import AllTasks from './tasks-bot/components/AllTasks.svelte'
    import TaskAdd from './tasks-bot/components/TaskAdd.svelte'
    import TaskEdit from './tasks-bot/components/TaskEdit.svelte'
    import TasksCategories from './tasks-bot/components/Categories.svelte'
    import TasksCategoryAdd from './tasks-bot/components/CategoryAdd.svelte'
    import TasksCategoryEdit from './tasks-bot/components/CategoryEdit.svelte'
    import TasksProfile from './tasks-bot/components/Profile.svelte'
    import TasksLeaderboard from './tasks-bot/components/Leaderboard.svelte'
    import TasksSearch from './tasks-bot/components/Search.svelte'

    import KUserTasks from './kitsune-bot/UserTasks.svelte'
    import KAllTasks from './kitsune-bot/components/AllTasks.svelte'
    import KTaskAdd from './kitsune-bot/components/TaskAdd.svelte'
    import KTaskEdit from './kitsune-bot/components/TaskEdit.svelte'
    import KTasksCategories from './kitsune-bot/components/Categories.svelte'
    import KTasksCategoryAdd from './kitsune-bot/components/CategoryAdd.svelte'
    import KTasksCategoryEdit from './kitsune-bot/components/CategoryEdit.svelte'
    import KTasksProfile from './kitsune-bot/components/Profile.svelte'
    import KLeaderboard from './kitsune-bot/components/Leaderboard.svelte'
    import KSearch from './kitsune-bot/components/Search.svelte'

    import Settings from './settings/Settings.svelte'
    import RouteAuthOnly from '../#common/authOnly/RouteAuthOnly.svelte'
    import TwoFactor from 'src/components/cabinet/two-factor/TwoFactor.svelte'
    import ConfirmIP from 'src/components/cabinet/confirm-ip/ConfirmIP.svelte'
    import Error404 from "./404/404.svelte"
    import MergeGames from './analytics/MergeGames.svelte';
    import Activity from './analytics/Activity.svelte';
    import Wallet from './analytics/Wallet.svelte';
    import SwapAnalytics from './analytics/Swap.svelte';
</script>

<Route path="/">
    {#if !$isLoggedIn}
        <Login/>
    {:else if $session?.isNeed2fa}
        <TwoFactor/>
    {:else if $session?.isNeedCode}
        <ConfirmIP/>
    {:else}
        <Dashboard/>
    {/if}
</Route>
<Route><Error404/></Route>

<RouteAuthOnly path="analytics" allowPermissions={["analytics"]}><Analytics/></RouteAuthOnly>
<RouteAuthOnly path="analytics/merge" allowPermissions={["analytics"]}><MergeGames/></RouteAuthOnly>
<RouteAuthOnly path="analytics/swap" allowPermissions={["analytics"]}><SwapAnalytics/></RouteAuthOnly>
<RouteAuthOnly path="analytics/wallet" allowPermissions={["analytics"]}><Wallet/></RouteAuthOnly>
<RouteAuthOnly path="analytics/activity" allowPermissions={["analytics"]}><Activity/></RouteAuthOnly>

<RouteAuthOnly path="transactions" allowPermissions={["transactions"]}><Transactions/></RouteAuthOnly>
<RouteAuthOnly path="refunds" allowPermissions={["transactions"]}><Refunds/></RouteAuthOnly>
<RouteAuthOnly path="withdrawals" allowPermissions={["transactions"]}><Withdrawals/></RouteAuthOnly>
<RouteAuthOnly path="deposits" allowPermissions={["transactions"]}><Deposits/></RouteAuthOnly>
<RouteAuthOnly path="marketplace" allowPermissions={["transactions"]}><Marketplace/></RouteAuthOnly>
<RouteAuthOnly path="swaps" allowPermissions={["transactions"]}><Swaps/></RouteAuthOnly>

<RouteAuthOnly path="users" allowPermissions={["users"]}><Users/></RouteAuthOnly>
<RouteAuthOnly path="holders" allowPermissions={["holders"]}><Holders/></RouteAuthOnly>
<RouteAuthOnly path="multiaccounts" allowPermissions={["multiaccounts"]}><MultiAccounts/></RouteAuthOnly>
<RouteAuthOnly path="profile/:userId" allowPermissions={["users"]} let:params><Profile userId={params.userId}/></RouteAuthOnly>
<RouteAuthOnly path="membership-owners" allowPermissions={["users"]} let:params><MembershipOwners/></RouteAuthOnly>

<RouteAuthOnly path="memberships" allowPermissions={["memberships"]}><Memberships/></RouteAuthOnly>
<RouteAuthOnly path="memberships/add" allowPermissions={["memberships"]}><MembershipAdd/></RouteAuthOnly>
<RouteAuthOnly path="memberships/edit/:id" allowPermissions={["memberships"]} let:params><Membership id={params.id}/></RouteAuthOnly>

<RouteAuthOnly path="notifications" allowPermissions={["notifications"]}><Notifications/></RouteAuthOnly>

<RouteAuthOnly path="administrators" allowPermissions={["administrators"]}><Administrators/></RouteAuthOnly>
<RouteAuthOnly path="administrators/role/add" allowPermissions={["administrators"]}><AdministratorsRoleAdd/></RouteAuthOnly>
<RouteAuthOnly path="administrators/role/edit/:role" allowPermissions={["administrators"]} let:params><AdministratorsRoleEdit role={params.role}/></RouteAuthOnly>

<RouteAuthOnly path="swap" allowPermissions={["swap"]}><Swap/></RouteAuthOnly>
<RouteAuthOnly path="swap/edit/:id" allowPermissions={["swap"]} let:params><SwapEdit id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="swap/add" allowPermissions={["swap"]}><SwapAdd/></RouteAuthOnly>
<RouteAuthOnly path="swap/tokens" allowPermissions={["swap"]}><SwapTokens/></RouteAuthOnly>
<RouteAuthOnly path="swap/token/add" allowPermissions={["swap"]}><SwapTokenAdd/></RouteAuthOnly>
<RouteAuthOnly path="swap/token/edit/:id" allowPermissions={["swap"]} let:params><SwapTokenEdit id={params.id}/></RouteAuthOnly>

<RouteAuthOnly path="nft" allowPermissions={["nft"]}><Nft/></RouteAuthOnly>
<RouteAuthOnly path="nft/images" allowPermissions={["nft"]}><NftImages/></RouteAuthOnly>
<RouteAuthOnly path="nft/items" allowPermissions={["nft"]}><NftItems/></RouteAuthOnly>

<RouteAuthOnly path="deposit-wallets" allowPermissions={["deposit-wallets"]}><DepositWallets/></RouteAuthOnly>

<RouteAuthOnly path="emails" allowPermissions={["emails"]}><Emails/></RouteAuthOnly>
<RouteAuthOnly path="emails/add" allowPermissions={["emails"]}><EmailAdd/></RouteAuthOnly>
<RouteAuthOnly path="emails/edit/:key" allowPermissions={["emails"]} let:params><EmailEdit key={params.key}/></RouteAuthOnly>

<RouteAuthOnly path="blog" allowPermissions={["blog"]}><Blog/></RouteAuthOnly>
<RouteAuthOnly path="blog/article/add" allowPermissions={["blog"]}><BlogArticleAdd/></RouteAuthOnly>
<RouteAuthOnly path="blog/article/edit/:id" allowPermissions={["blog"]} let:params><BlogArticleEdit id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="blog/categories" allowPermissions={["blog"]}><BlogCategories/></RouteAuthOnly>
<RouteAuthOnly path="blog/category/add" allowPermissions={["blog"]}><BlogCategoryAdd/></RouteAuthOnly>
<RouteAuthOnly path="blog/category/edit/:id" allowPermissions={["blog"]} let:params><BlogCategoryEdit id={params.id}/></RouteAuthOnly>

<RouteAuthOnly path="polls" allowPermissions={["blog"]}><Poll/></RouteAuthOnly>
<RouteAuthOnly path="polls/add" allowPermissions={["blog"]}><PollAdd/></RouteAuthOnly>
<RouteAuthOnly path="polls/edit/:id" allowPermissions={["blog"]} let:params><PollEdit id={params.id}/></RouteAuthOnly>

<RouteAuthOnly path="news" allowPermissions={["blog"]}><News/></RouteAuthOnly>
<RouteAuthOnly path="news/add" allowPermissions={["blog"]}><NewsAdd/></RouteAuthOnly>
<RouteAuthOnly path="news/edit/:id" allowPermissions={["blog"]} let:params><NewsEdit id={params.id}/></RouteAuthOnly>

<RouteAuthOnly path="confirmations" allowPermissions={["confirmations"]}><Confirmations/></RouteAuthOnly>
<RouteAuthOnly path="actions" allowPermissions={["actions"]}><Actions/></RouteAuthOnly>

<RouteAuthOnly path="app-configs" allowPermissions={["app-configs"]}><AppConfigs/></RouteAuthOnly>
<RouteAuthOnly path="app-config/:id" allowPermissions={["app-configs"]} let:params><AppConfigsApp id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="app-config/create" allowPermissions={["app-configs"]}><AppConfigsApp/></RouteAuthOnly>

<RouteAuthOnly path="tasks" allowPermissions={["tasks"]}><UserTasks/></RouteAuthOnly>
<RouteAuthOnly path="tasks/all" allowPermissions={["tasks"]}><AllTasks/></RouteAuthOnly>
<RouteAuthOnly path="tasks/add" allowPermissions={["tasks"]}><TaskAdd/></RouteAuthOnly>
<RouteAuthOnly path="tasks/edit/:id" allowPermissions={["tasks"]} let:params><TaskEdit id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="tasks/categories" allowPermissions={["tasks"]}><TasksCategories/></RouteAuthOnly>
<RouteAuthOnly path="tasks/category/add" allowPermissions={["tasks"]}><TasksCategoryAdd/></RouteAuthOnly>
<RouteAuthOnly path="tasks/category/edit/:id" allowPermissions={["tasks"]} let:params><TasksCategoryEdit id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="tasks/profile/:id" allowPermissions={["tasks"]} let:params><TasksProfile id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="tasks/leaderboard" allowPermissions={["tasks"]}><TasksLeaderboard/></RouteAuthOnly>
<RouteAuthOnly path="tasks/search" allowPermissions={["tasks"]}><TasksSearch/></RouteAuthOnly>

<RouteAuthOnly path="k-tasks" allowPermissions={["tasks"]}><KUserTasks/></RouteAuthOnly>
<RouteAuthOnly path="k-tasks/all" allowPermissions={["tasks"]}><KAllTasks/></RouteAuthOnly>
<RouteAuthOnly path="k-tasks/add" allowPermissions={["tasks"]}><KTaskAdd/></RouteAuthOnly>
<RouteAuthOnly path="k-tasks/edit/:id" allowPermissions={["tasks"]} let:params><KTaskEdit id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="k-tasks/categories" allowPermissions={["tasks"]}><KTasksCategories/></RouteAuthOnly>
<RouteAuthOnly path="k-tasks/category/add" allowPermissions={["tasks"]}><KTasksCategoryAdd/></RouteAuthOnly>
<RouteAuthOnly path="k-tasks/category/edit/:id" allowPermissions={["tasks"]} let:params><KTasksCategoryEdit id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="k-tasks/profile/:id" allowPermissions={["tasks"]} let:params><KTasksProfile id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="k-tasks/leaderboard" allowPermissions={["tasks"]}><KLeaderboard/></RouteAuthOnly>
<RouteAuthOnly path="k-tasks/search" allowPermissions={["tasks"]}><KSearch/></RouteAuthOnly>

<RouteAuthOnly path="settings" allowPermissions={["settings"]}><Settings/></RouteAuthOnly>
